import React, { memo, useEffect, useRef } from "react"
import { Link } from "gatsby"
import { Autoplay } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import AOS from "aos"
import "aos/dist/aos.css"
import OptimizedImage from "../../ImageShow/OptimizedImage"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import * as style from "./ourAlliance.module.css"

const OurAlliance = ({
  CustomClass,
  homeAllianceSection,
  homeAllianceImageList,
  homeAllianceTitle,
  homeAllianceContent,
  homeAllianceSubTitle,
}) => {
  const sliderWrap = useRef()

  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  return (
    <>
      {homeAllianceSection === "yes" && (
        <section
          className={`partner_client section_common_padding ${style.client_partner} ${CustomClass}`}
          data-aos="fade-up"
          data-aos-delay="50"
        >
          <div className="container">
            <div className="row">
              <div>
                <SectionsTitle
                  title={homeAllianceTitle}
                  SubTitle={homeAllianceSubTitle}
                  Content={homeAllianceContent}
                  btnName="View All"
                  href={`/awards/`}
                // styleCss={{ display: "none" }}
                />
              </div>
            </div>
            <div className="swiper-slider client-logo-slider">
              <Swiper
                autoplay={{
                  delay: 0,
                  disableOnInteraction: false,
                }}
                speed={7000}
                modules={[Autoplay]}
                className={`infraSlider ${style.our_alliance_swiper_wrapper}`}
                loopAdditionalSlides={1}
                loop={true}
                slidesPerView="auto"
                allowTouchMove={false}
                spaceBetween={30}
                style={{ transitionTimingFunction: "linear" }}
                ref={sliderWrap}
                breakpoints={{
                  0: {
                    // slidesPerView: 3,
                    spaceBetween: 16,
                  },
                  575: {
                    // slidesPerView: 3,
                    spaceBetween: 16,
                  },
                  576: {
                    // slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  768: {
                    // slidesPerView: 4,
                    spaceBetween: 20,
                  },
                  1024: {
                    // slidesPerView: 5,
                    spaceBetween: 30,
                  },
                  1200: {
                    // slidesPerView: 6,
                    spaceBetween: 30,
                  },
                }}
              >
                <div className="swiper-wrapper">
                  {homeAllianceImageList?.map((it, ind) => {
                    return (
                      <SwiperSlide key={ind}>
                        <Link to={it.homeAllianceListLink} target="_blank">
                          <div>
                            <OptimizedImage
                              imageData={
                                it?.homeAllianceListImage?.mediaItemUrl
                                  ? it?.homeAllianceListImage?.mediaItemUrl
                                  : "/images/placeholder-image.jpg"
                              }
                              alt={it?.homeAllianceListImage?.altText}
                            />
                          </div>
                        </Link>
                      </SwiperSlide>
                    )
                  })}
                </div>
              </Swiper>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(OurAlliance)
